import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const MEDIA_DOMAIN_INTRO = {
  title: "Media & Entertainment",
  content: "Agentic AI workflow automation for Media & Entertainment — across Entertainment and Digital Media. Use cases span subtitling and localization workflow and social listening with response routing. Practical deployments for media companies in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "Media entertainment agentic AI — subtitling localization workflow, social listening response routing. MAM CMS CRM social platforms integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const MEDIA_SYSTEMS = "MAM, CMS, CRM, Social Platforms, Email, Power BI";

const RAW = [
  {
    id: "subtitling-and-localization-workflow",
    subIndustry: "Entertainment",
    department: "Localization",
    businessProcess: "Subtitling and localization workflow",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Subtitling and localization workflow",
    title: "Subtitling And Localization Workflow Automation for Media & Entertainment",
    seoKeywords: "media & entertainment, subtitling and localization workflow, AI automation, RPA, agentic AI",
    challenge: "Subtitles, translations, reviews and approvals are coordinated manually.",
    solution: "Implement AI Agent + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Entertainment teams can improve subtitling and localization workflow with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "AI Agent + Workflow Automation",
    buyerPersona: "Localization Head",
    systems: MEDIA_SYSTEMS,
    agentsRequired: "Subtitling AI Agent, Validation Agent, Human Review Agent",
    inputData: "Emails, forms, system records, task notes, master data and subtitling and localization workflow process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for subtitling and localization workflow",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "social-listening-and-response-routing",
    subIndustry: "Digital Media",
    department: "Social",
    businessProcess: "Social listening and response routing",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Social listening and response routing",
    title: "Social Listening And Response Routing Automation for Media & Entertainment",
    seoKeywords: "media & entertainment, social listening and response routing, AI automation, RPA, agentic AI",
    challenge: "Social comments and mentions are manually monitored and escalated.",
    solution: "Implement AI Agent + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Digital Media teams can improve social listening and response routing with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "AI Agent + Workflow Automation",
    buyerPersona: "Social Media Head",
    systems: MEDIA_SYSTEMS,
    agentsRequired: "Social AI Agent, Validation Agent, Human Review Agent",
    inputData: "Emails, forms, system records, task notes, master data and social listening and response routing process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for social listening and response routing",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
];
export const MEDIA_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Entertainment", "Digital Media"];
export const MEDIA_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => MEDIA_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'media-domain', domainIntro: MEDIA_DOMAIN_INTRO, useCases: MEDIA_USE_CASES });
export const MEDIA_USE_CASES_SEO = seo.useCasesSeo;
export const MEDIA_DOMAIN_FAQS = seo.domainFaqs;
export const MEDIA_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const MEDIA_FAQ_JSONLD = seo.faqJsonLd;
export const MEDIA_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const MEDIA_WEBPAGE_JSONLD = seo.webPageJsonLd;

